import React, { Component } from 'react';
import { connect } from 'react-redux';
import TableParent from '../commonComponents/TableParent';
import CallAPI from '../commonComponents/AxiosHelper';
import LoadingComponent from '../commonComponents/LoadingComponent';
import ErrorComponent from '../commonComponents/ErrorComponent';
import Form from '../commonComponents/Form.v2';
import * as csv from 'csvtojson';
import DatasetFilter from '../commonComponents/DatasetFilter';
import sanitizeHtml from 'sanitize-html';

class SegmentComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            ...props,
            property: null,
            clearFlag: null,
            accessError:null,
            defaultFormula: {
                "sum": { "name": "Sum", "value": "sum", },
                "avg": { "name": "Average", "value": "avg" },
                "None": { "name": "None", "value": "" },
            },
            isDerived: {
                "0": { name: "Default", value: "0" },
                "2": { name: "Derived", value: "2" },
                "3": { name: "Dynamic Segment", value: "3" },
                "1": { name: "Default", value: "1" },
                "": { name: "Default", value: "1" }
            },
            isDisplay: {
                "1": { name: "Show", value: "1" },
                "0": { name: "Hide", value: "0" },
                "2": { name: "Delete", value: "2" }
            },
            consider_values: {
                "yes": { name: "YES", value: "yes" },
                "no": { name: "NO", value: "no" },
              
            },
            sort_order: {
                "1": { name: "Asc", value: "asc" },
                "0": { name: "Desc", value: "desc" },
                "None": { "name": "None", "value": "" },
            }
        };

        this.formData = {
            "name": { "name": "name", "label": "Label", "type": "text", "requiredFlag": true },
            "formulae": {
                "name": "formulae", "label": "SQL Logic", "type": "text-large", "requiredFlag": true
            }
        }

        this.bulkFormData = {
            "isDisplay": {
                "name": "isDisplay", "label": "Display", "type": "dropdown", "options": [
                    { "name": "Select Option", "value": "" },
                    { "name": "Show", "value": "1" },
                    { "name": "Hide", "value": "0" },
                    { "name": "Delete", "value": "2" },
                ], "requiredFlag": true
            },
            "consider_values": {
                "name": "consider_values", "label": "Filter", "type": "dropdown", "options": [
                    { "name": "Select Option", "value": "" },
                    { "name": "YES", "value": "YES" },
                    { "name": "No", "value": "NO" },
                ], "requiredFlag": true
            },
            "sort_order": {
                "name": "sort_order", "label": "Sort Order", "type": "dropdown", "options": [
                    { "name": "Select Option", "value": "" },
                    { "name": "Asc", "value": "asec" },
                    { "name": "Desc", "value": "desc" },
                ], "requiredFlag": true
            }
         
        }
    this.importFormData = {
            "fileImport": {
                "name": "fileImport", "label": "File Import", "type": "file"
            }
        }

        this.headerMapping = {
            "name": "Name",
            "isDerived": "Metric Type",
            "formula": "Formulae",
            "defaultFormula": "Aggregation Type",
            // "isDisplay": "Display",
            // "isFilter":"Filter",
            // "isSort":"Sort",
        }
        this.buttons = {
            "addButton": [{ "id": "addButton", "label": "Add Segment", "type": "normal", "display": true, "action": "add", 'modal_id': "#addContent" }],
            "dropdownConfig": [{
                "id": "id", "label": "More", "type": "dropdown", "display": true,"position":"right", "order":1,
                "children": [
                    // { "id": "fileFormat", "label": "File Format Download", "action": "file" },
                    { "id": "exportCSV", "label": "Export CSV", "action": "export" },
                    // { "id": "importCSV", "label": "Import CSV", "action": "import" },
                ]
            }],
            "editButton": [{ "id": "editButton", "class": "", "label": "Edit", "type": "normal", "display": true, "action": "edit", 'modal_id': null, "position": "right","order":2}],
            "saveButton": [{
                "id": "saveButton", "class": "", "label": "Save", "type": "normal", "display": false, "action": "save", 'modal_id': null, "position": "right","order":3
            }],
            "cancelButton": [{ "id": "cancelButton", "class": "", "label": "Cancel", "type": "normal", "display": false, "action": "cancel", 'modal_id': null, "position": "right", "order": 4}],
            "loadingButton": [{ "id": "loadingButton", "type": "loading", "display": false, "action": "load" }]
        }


        this.change_handle = this.change_handle.bind(this);
        this.saveHandle = this.saveHandle.bind(this);
        this.change_table_format = this.change_table_format.bind(this);
        this.handleDataUpdate = this.handleDataUpdate.bind(this);
        this.text_to_json = this.text_to_json.bind(this);
        this.fetchPropertyData = this.fetchPropertyData.bind(this);
        this.submitHandle = this.submitHandle.bind(this);
        this.getJSON = this.getJSON.bind(this);
        this.formatColumnStatus = this.formatColumnStatus.bind(this);
    }

    componentWillMount() {
        this.fetchPropertyData();
    }

    componentDidUpdate(prevProps, nextState) {
        if (prevProps.datasetValue !== this.props.datasetValue) {
            let that = this;
            this.fetchPropertyData();
        }
        // jQuery('[data-toggle="popover"]').popover();

    }

    fetchPropertyData() {
        let that = this;
        this.setState({
            property: null, accessError:null
        })
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId: null,
            toolId: this.props.datasetValue
        }
        CallAPI('get', '/app/getProperty', null, params, 0, function (response) {
            if(response?.status==500){
                that.setState({accessError:true});
            }
            that.setState({ property: response });

        },this.props.authData)
    }


    componentDidMount() {
        jQuery(".custom-file-input").on("change", function () {
            var fileName = jQuery(this).val().split("\\").pop();
            jQuery(this).siblings(".custom-file-label").addClass("selected").html(fileName);
        });
    }

    change_table_format(array_data) {
        
        try {
            var that = this;
            let temp_array = [];
            array_data.map(function (innerData, index) {

                let inner_temp_array = [];

                inner_temp_array.updated_by = innerData.updated_by;
                inner_temp_array.updated_time = innerData.updated_time;
                inner_temp_array.name = innerData.name;
                inner_temp_array.label = innerData.value;
                inner_temp_array.formulae = innerData.formulae;
                inner_temp_array.isDisplay = innerData.isDisplay !== undefined ? that.state.isDisplay[innerData.isDisplay].name : innerData[that.headerMapping['isDisplay']];
                inner_temp_array.consider_values = innerData.consider_values
                inner_temp_array.sort_order = (['', null, undefined].indexOf(innerData.sort_order) !== -1) ? that.state.sort_order['None'].name : capitalizeFirstChar(innerData.sort_order)

                innerData.type = innerData.type ? (innerData.type == "state" || innerData.type == "district" || innerData.type == 'pincode' ? "1" : innerData.type) : "1";
                inner_temp_array.type = innerData.type ? that.state.isDerived[innerData.type].name : innerData[that.headerMapping['isDerived']];

                inner_temp_array.value = innerData.value;

                temp_array.push(inner_temp_array);
            })

            return { data: temp_array };
        } catch (e) {
            return "error";
        }
    }

    // change form submit handle
    saveHandle(e) {
        let form_array = jQuery("#add_form").serializeArray();
        let paramArray = {}, checkValidity = true
        form_array.map(function (innerData) {
            if (checkValidity) {
                if (innerData.name === 'formulae') {
                    var encodedLogic = $('<div />').text(innerData.value).html();
                    checkValidity = ['=', '+', '-', '@'].indexOf(innerData.value.charAt(0)) > -1 ? false : true
                } else {
                    checkValidity = checkSpecialChars(innerData.value, 'propertyLabel') ? false : true
                }
                checkValidity
                    ? innerData.name == 'formulae'
                        ? paramArray[innerData.name] = encodedLogic
                        : paramArray[innerData.name] = sanitizeHtml(innerData.value)
                    : null;
            }
        })
        if (checkValidity === false) {
            alert('Please enter valid inputs!');
        }
        else {
            // paramArray['value'] = '2';
            // paramArray['value'] = paramArray['name'].trim().replace(/\W/g, '').toLowerCase().split(' ').join('_');
            paramArray['value'] = paramArray['name'].trim().toLowerCase();
            paramArray['type'] = '2';
            paramArray['isDisplay'] = '1';
            paramArray['formulae'] = paramArray['formulae'];
            paramArray['rockmetric_update'] = true;
            paramArray['rockmetric_new_entry'] = true;
            let property = this.state.property

            property.unshift(paramArray);

            this.setState({ property: property })

            jQuery("#addContent").modal('toggle');
            // this.TableParent.handleButton(null, 1);
            jQuery("#addContent").trigger("reset");
        }
        e.preventDefault();
    }

    // handle popout submit button
    change_handle(data) {
        let property = this.state.property;
        let final_value = data.value;
        let field = data.colDef.field == "label" ? "name" : data.colDef.field;
        let checkValidity = true
        if (field === 'formulae') {
            var encodedLogic = $('<div />').text(final_value).html();
            checkValidity = ['=', '+', '-', '@'].indexOf(final_value.charAt(0)) > -1 ? false : true
        } else if (field === 'name') {
            checkValidity = checkSpecialChars(final_value, 'propertyLabel') ? false : true
        }
        if (checkValidity === false) {
            alert("Please enter valid inputs!");
            this.setState({ property: property })
        } else {
            if (this.state[data.colDef.field]) {
                Object.values(this.state[data.colDef.field]).map(function (innerData) {
                    if (innerData.name == data.value) {
                        final_value = innerData.value;
                    }
                })
            }
            if (final_value !== property[data.node.id][field]) {
                if (field == 'formulae') {
                    property[data.node.id][field] = encodedLogic;    
                } else {
                    property[data.node.id][field] = final_value;
                }                
                property[data.node.id]['rockmetric_update'] = true;
                if (property[data.node.id]['rockmetric_update_columns'] == undefined) {
                    property[data.node.id]['rockmetric_update_columns'] = []
                }
                property[data.node.id]['rockmetric_update_columns'].push(field);
                property[data.node.id]['rockmetric_update_columns'] = [...new Set(property[data.node.id]['rockmetric_update_columns'])];
            }
        }
    }



    //For adding new Derived Metrics
    submitHandle() {
        let that = this;
        let params = {
            // siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            // toolId: this.props.datasetValue,
            // email: this.props.authData.username
        }
        let filteredArray = this.state.property.filter((element, i) => {
            return element.rockmetric_update == true;
        });
        filteredArray = Array.isArray(filteredArray) && filteredArray.length ? filteredArray : []
        filteredArray[0]['siteId'] = localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null
        filteredArray[0]['toolId'] = this.props.datasetValue
        filteredArray[0]['updated_by'] = this.props.authData.username        
        if (confirm("Please Confirm to Update!")) {
            isAdHocDataLoading();
            CallAPI('POST', '/app/addProperty', filteredArray, params, 0, function (response) {
                if (response.status) {
                    alert("Successfully Submitted");
                    // window.location.reload();
                }
                else if (Array.isArray(response.information) && !response.status) {
                    let errorInfo = "";
                    for (let i = 0; i < response.information.length; i++) {
                        errorInfo += `${i + 1}.${response.information[i]['information']}.\n`;
                    }
                    alert(errorInfo);
                }
                else {
                    alert(response.information);
                }
                that.fetchPropertyData();
            }, this.props.authData);
        }
    }


    exportFile(params) {
        gridOptions.api.shouldRowBeSkipped();
    }


    text_to_json(data) {
        let that = this;
        csv({
            output: "json",
            noheader: false,
            headers: Object.keys(this.headerMapping),
            // nullObject:true,
            colParser: {
                "isDerived": function (item, head, resultRow, row, colIdx) {
                    let metricType = that.getJSON(Object.values(that.state[head]));
                    return metricType[item] ? metricType[item] : null;
                },
                "isDisplay": function (item, head, resultRow, row, colIdx) {
                    let displayType = that.getJSON(Object.values(that.state[head]));
                    return displayType[item] ? displayType[item] : null;
                }
            }
        }).fromString(data)
            .then(function (result) {
                let metric = that.state.metric;

                metric.metric = [...result, ...metric.metric];
                that.setState({
                    metric: metric
                });
            })
    }


    handleDataUpdate(data) {
        let property = this.state.property;
        property = data;
        this.setState({
            property: property
        })
    }


    getJSON(data) {
        let result = {};
        data.map((element, i) => {
            result[element.name] = element.value;
        });
        return result;
    }

    formatColumnStatus(params){
        let htmlString = `<span>${params.value}</span>`;
        let index = params.node.id;
        let icon = '';
        let statusObj = this.state.property[index]['status'];
        if (statusObj !== null && statusObj !== undefined ){
            let status = JSON.parse(statusObj);
            if (status !== null && status !== undefined) {
                let id = `${params.value}_${index}`;
                if (status.status) {
                    // icon = '<i class="fas fa-check-circle mg-t-2 float-right mg-t-5" style="color:#04cc82"></i>';
                    icon = '<i id="' + id +'" class="fas fa-check-circle mg-t-2 float-right mg-t-5" style="color:#04cc82"></i>';
                }
                else {
                    let error_message = status.error_message;
                    // icon = '<i id="' + id +'" class="fas fa-exclamation-circle float-right mg-t-5" data-container="body" data-toggle="tooltip" data-placement="bottom" title="'+error_message+'" style="color:#ff726f"></i>';
                   
                    icon = '<i id="' + id +'" class="fas fa-exclamation-circle float-right mg-t-5" data-container="body" data-toggle="popover" data-placement="bottom"  data-content="'+error_message+'" style="color:#ff726f"></i>';
                    // icon = `<i class="fas fa-exclamation-circle mg-t-2 float-right" data-container="body" data-toggle="popover" data-placement="bottom" data-content="Vivamus sagittis lacus vel augue laoreet rutrum faucibus." style="color:#ff726f"></i>`;
                }

                htmlString = `<span>${params.value}${icon}</span>`;
            }
        }
      
        return htmlString;
    }

    render() {

        var mainData = <LoadingComponent/>;
        if (this.state.property) {
            let final_data = this.change_table_format(this.state.property);

            if (final_data !== "error") {

                let isDisplay = Object.values(this.state.isDisplay).map(function (value) {
                    return value.name;
                });
                let consider_values =Object.values(this.state.consider_values).map(function (value) {
                    return value.name;
                });
                let sort_order =Object.values(this.state.sort_order).map(function (value) {
                    return value.name;
                });

                var columns_array = [
                    { label: "Label", value: "name", type: "html", editable: true, hide: false, dataType: 'string' },
                    { label: "Logic", value: "formulae", type: "html", cellEditor: "agLargeTextCellEditor", hide: false, editable: true, dataType: 'string' },
                    { label: "Dimension Type", value: "type", type: "html", dataType: 'string',hide:false },
                    { label: "Display", value: "isDisplay", type: "html", type: "html", dropdown_value: isDisplay, editable: true, hide: false, dataType: 'string' },
                    { label: "Consider value in filter", value: "consider_values", type: "html", type: "html", dropdown_value: consider_values, editable: true, hide: false, dataType: 'string' },
                    { label: "Sort Order", value: "sort_order", type: "html", type: "html", dropdown_value: sort_order, editable: true, hide: false, dataType: 'string' },
                    { label: "Updated By", value: "updated_by", type: "html", hide: true, dataType: 'string' },
                    { label: "Updated Time", value: "updated_time", type: "html", type: "html", hide: true, dataType: 'string' }
                ];


                var firstColumn = "Column Name";
                var Form_Data = <Form label_array={this.formData} call_back={this.call_back_form} />;
                var Bulk_Form_Data = <Form label_array={this.bulkFormData} call_back={this.call_back_form} />;
                var import_Form_Data = <Form label_array={this.importFormData} call_back={this.call_back_form} />;

                var modals = {
                    "addModal": {
                        "form_name": "add_form", "title": "Add Segments", "body": Form_Data, "button_name": "Add", "action": "add", "display": true, buttonType: "submit"
                    },
                    "bulkModal": {
                        "form_name": "bulk_form", "title": "Edit Segments", "body": Bulk_Form_Data, "button_name": "Update", "action": "bulk", "display": true, buttonType: "submit"
                    },
                    "importModal": {
                        "form_name": "import_form", "title": "Import Segments", "body": import_Form_Data, "button_name": "Import", "action": "import", "display": true, buttonType: "submit"
                    }
                }

                mainData = <TableParent
                    ref={(ref) => { this.tableRef = ref }}
                    data={final_data}
                    parentConfig={this.state}
                    columns_array={columns_array}
                    firstColumn={firstColumn}
                    editData={this.state.property}
                    modalConfig={modals}
                    onCellChange={this.change_handle}
                    // actionArray={this.props.menuData}
                    menuAction={this.handleMenuAction}
                    handleDataUpdate={this.handleDataUpdate}
                    saveHandle={this.saveHandle}
                    buttonConfig={this.buttons}
                    submitHandle={this.submitHandle}
                    importJSON={this.text_to_json}
                    rowSelection="multiple"
                    firstCellRender={this.formatColumnStatus}
                />
            }
            else{
                mainData = this.state.accessError ? <div className="d-flex">
                    <div class="alert alert-danger h-25 mg-b-0 mg-t-5" role="alert"><i data-feather="alert-circle" class="mg-r-10"></i>
                        This dataset don’t have admin access. Kindly provide admin access. <a href="/admin/useraccess" class="alert-link" target="_blank">Click here for grant permission</a>
                    </div>
                </div> : <ErrorComponent />;

            }
        }

        return (
            <div className="">
                <div className="wd-300">
                    <DatasetFilter />
                </div>
                {mainData}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { 
        toolId: state.admin.toolId,
        authData: state.dataSet.authData
    };
}

export default connect(mapStateToProps, null)(SegmentComponent);